import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import React from "react";

const Exporters = {
  exportToExcel: (data, title = "Sheet1", filename = "export.xlsx") => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, title);
    XLSX.writeFile(wb, filename);
  },
  exportToCSV: (data, filename = "export.csv") => {
    const ws = XLSX.utils.json_to_sheet(data);
    const csv = XLSX.utils.sheet_to_csv(ws);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  exportToPDF: (table, filename = "export.pdf") => {
    const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });

    const margin = 20;
    const pageWidth = doc.internal.pageSize.getWidth() - margin * 2;

    const columns = table
      .getAllLeafColumns()
      .slice(1, -1)
      .map(col => ({
        header: col.columnDef.header,
        dataKey: col.id,
      }));

    const rows = table.getRowModel().rows.map(row => {
      const rowData = {};
      row.getVisibleCells().forEach(cell => {
        const value = cell.getValue();

        if (React.isValidElement(value)) {
          if (value.type === "input" && value.props.type === "checkbox") {
            rowData[cell.column.id] = value.props.checked ? "✔️" : "❌";
          } else {
            rowData[cell.column.id] = "";
          }
        } else {
          rowData[cell.column.id] =
            typeof value === "string" || typeof value === "number"
              ? String(value)
              : "";
        }
      });
      return rowData;
    });

    if (!rows.length) return;

    doc.setFontSize(14);
    doc.text("Relatório da Tabela", margin, 30);

    autoTable(doc, {
      startY: 50,
      head: [columns.map(c => c.header)],
      body: rows.map(row => columns.map(c => row[c.dataKey])),
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 4,
        overflow: "linebreak",
        halign: "left",
        valign: "middle",
      },
      headStyles: {
        fillColor: [230, 230, 230],
        textColor: 20,
        fontStyle: "bold",
      },
      columnStyles: columns.reduce((acc, col) => {
        acc[col.dataKey] = { cellWidth: "wrap" };
        return acc;
      }, {}),
      didDrawPage: data => {
        // Ajusta o título na parte superior
        doc.setFontSize(10);
        const pageCount = doc.internal.getNumberOfPages();
        doc.text(
          `Página ${pageCount}`,
          pageWidth + margin - 60,
          doc.internal.pageSize.getHeight() - 10
        );
      },
      tableWidth: "wrap",
      horizontalPageBreak: true,
      margin: { left: margin, right: margin },
    });

    // Ajusta automaticamente o tamanho da tabela à página
    const scaleFactor =
      pageWidth / doc.lastAutoTable.finalWidth > 1
        ? 1
        : pageWidth / doc.lastAutoTable.finalWidth;

    if (scaleFactor < 1) {
      const pages = doc.internal.getNumberOfPages();
      const scaledDoc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
      for (let i = 1; i <= pages; i++) {
        scaledDoc.addImage(
          doc.getPage(i),
          "JPEG",
          margin,
          0,
          pageWidth * scaleFactor,
          doc.internal.pageSize.getHeight()
        );
        if (i < pages) scaledDoc.addPage();
      }
      scaledDoc.save(filename);
    } else {
      doc.save(filename);
    }
  }

};

export default Exporters;